<div
  class="site-user-trial-list"
  [ngClass]="{ 'visibility-hidden': !showAssignForm }"
>
  <div class="row">
    <div class="text-right col-12">
      <app-button
        text="Assign Site Contact"
        variant="info"
        size="sm"
        (clicked)="onHandleShowAssignTrial()"
      />
    </div>
  </div>

  <div class="site-contacts-lists">
    @for (
      contact of assignedContacts;
      track contact.siteContactId;
      let i = $index
    ) {
      @if (!contact.deleted) {
        <div class="site-contact">
          <div class="site-contact__head">
            <div class="site-contact__head__left">
              <div class="site-contact__name__state">
                <span class="site-contact__name">{{ contact.fullname }}</span>
                <span
                  class="badge"
                  [ngClass]="{
                    'badge-success': contact.isActive,
                    'badge-warning': !contact.isActive,
                  }"
                  >{{ contact.isActive ? "Active" : "Inactive" }}</span
                >
              </div>

              <div class="site-contact__email">
                <i class="far fa-envelope"></i>
                <span>{{ contact.email }}</span>
              </div>

              <div class="site-contact__registration_sent">
                @if (
                  authService.hasPermission(
                    Permissions.SendSiteContactRegistrationLink
                  )
                ) {
                  <app-button
                    [text]="
                      contact.patientRegistrationCode
                        ? 'Resend Patient Registration Link'
                        : 'Send Patient Registration Link'
                    "
                    size="sm"
                    [isBusy]="buttonProcessing[i]"
                    [disabled]="buttonProcessing[i]"
                    (clicked)="
                      sendPatientRegistrationMail(contact.siteContactId, i)
                    "
                  />
                }

                @if (contact.patientRegistrationCode) {
                  <span class="registration-sent">Registration Link Sent</span>
                }
              </div>
            </div>

            <div class="site-contact__head_role">
              <strong>Role</strong>
              <span>{{ contact.roleName | pascalSpaces }}</span>
            </div>

            <div class="site-contact__head_blinded">
              <strong>Blinded</strong>
              <span>
                @if (contact.blinded) {
                  <i class="far fa-check"></i>
                } @else {
                  <i class="far fa-times"></i>
                }
              </span>
            </div>

            <div class="site-contact__head__right">
              <app-button
                text="Edit"
                variant="secondary"
                size="sm"
                (clicked)="onHandleEditAtIndex(i)"
              />
              <app-button
                text="Unassign"
                variant="info"
                size="sm"
                (clicked)="unassignModel.showUsingDeleteIndex(i)"
              />
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>

<div
  class="site-user-trial-assign"
  [ngClass]="{ 'visibility-hidden': showAssignForm }"
>
  <form [formGroup]="assignContactForm">
    <h2>
      <a (click)="onHandleReturnToForm()"
        ><i aria-hidden="true" class="far fa-angle-left"></i
      ></a>
      <span *ngIf="modifyAtIndex >= 0">Edit Site Contact</span>
      <span *ngIf="modifyAtIndex < 0">Assign Site Contact</span>
    </h2>

    <table aria-hidden="true" class="simple-form">
      <tr>
        <th style="min-width: 50px"><label [style.margin-top.px]="modifyAtIndex < 0 ? 20 : null">Site Contact</label></th>
        <td>
          <span *ngIf="modifyAtIndex >= 0" class="site-contact-name"
            >{{ assignedContacts[modifyAtIndex].fullname }} ({{
              assignedContacts[modifyAtIndex].email
            }})</span
          >

          <div [class.visibility-hidden]="modifyAtIndex >= 0">
            <app-site-contacts-dropdown
              #contactDropdown
              [options]="allContacts"
              [parentForm]="assignContactForm"
              controlName="siteContactId"
              [isBusy]="isLoadingContacts"
              [disabled]="!allContacts?.length"
              [placeholder]="!allContacts?.length ? 'No site contacts available' : 'Select site contact...'"
            ></app-site-contacts-dropdown>
            <br />
            <a
              (click)="createSiteContactModal.open()"
              class="btn btn-outline btn-outline-slim"
              >Add New Contact</a
            >
          </div>
        </td>
      </tr>

      <tr>
        <th style="vertical-align: middle; width: 120px">
          <label>Site Role</label>
        </th>
        <td>
          <app-dropdown-input
            #roleDropdown
            [parentForm]="assignContactForm"
            [options]="roleOptions"
            name="role"
            placeholder="Select role..."
          ></app-dropdown-input>
        </td>
      </tr>

      <tr>
        <th></th>
        <td>
          <app-switch-panel
            formControlName="blinded"
            label="Blinded"
            activeText="Note that blinded access means that this contact will not be able to register patients."
          ></app-switch-panel>
        </td>
      </tr>
      <tr>
        <th></th>
        <td>
          <div class="btn-wrap">
            <div class="row">
              <div class="col-6"></div>
              <div class="col-6">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    margin-bottom: 30px;
                  "
                >
                  @if (modifyAtIndex < 0) {
                    <app-button
                      text="Assign"
                      [disabled]="!assignContactForm.valid"
                      (clicked)="onHandleAssignContact()"
                    />
                  }

                  @if (modifyAtIndex >= 0) {
                    <app-button
                      text="Update"
                      [disabled]="!assignContactForm.valid"
                      (clicked)="onHandleUpdateSite(modifyAtIndex)"
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </form>
</div>

<!-- Start: Unassign site modal -->
<app-modal #unassignModel>
  <div class="modal-header">
    <h2 class="modal-title">Unassign Site Contact?</h2>
  </div>
  <div class="modal-body">
    <p>
      Are you sure you want to unassign the site contact from this trial/site?
    </p>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button
          text="Cancel"
          variant="secondary"
          width="fill"
          (clicked)="unassignModel.hide()"
        />
      </div>

      <div class="col-6">
        <app-button
          text="Unassign"
          width="fill"
          (clicked)="onHandleDeleteConfirmed(unassignModel.deleteIndex)"
        />
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Unassign site modal -->

<app-create-site-contact-modal #createSiteContactModal (siteContactCreated)="onHandleSiteContactCreated($event)" />
